// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-3275bbad] .van-cell-group {
  background-color: transparent;
}
[data-v-3275bbad] .van-cell {
  background-color: transparent;
}
[data-v-3275bbad] .van-field__control {
  text-align: right;
}
.name[data-v-3275bbad] .van-field__control {
  color:#969799 !important
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
